import { createAction } from 'redux-actions';
export const SET_THREAD_FILTER_VALUE = 'SET_THREAD_FILTER_VALUE';
export const setThreadFilterValue = createAction(SET_THREAD_FILTER_VALUE, (filterKey, filterValue) => ({
  filterKey,
  filterValue
}));